import "~/misc/common";

import '@claviska/jquery-minicolors';
import "jquery-minicolors/jquery.minicolors.css";
import '~/styles/colorpicker.scss';

$(() => {
  //console.log("minicolors.ts");
  $('[data-minicolors]').each(function (i, elem) {
    var input = $(this);
    //@ts-ignore
    input.minicolors(input.data('minicolors'));
  });
});
